import { useCallback, useMemo } from 'react';
import { useSetAtom } from 'jotai';

import { modalState } from '@/state/modal.state';
import { APP_USER_ROLES } from '@/types';
import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';
import { useUserRole } from '@/user/use-user-role';

export const useEnhanceButton = () => {
  const userRole = useUserRole();
  const { hasRequiredProduct } = useUserProducts();
  const setModalState = useSetAtom(modalState);

  const hasPermissionToEnhanceProject = useMemo(() => {
    return (
      userRole !== APP_USER_ROLES.GUEST &&
      hasRequiredProduct(PRODUCT.ENHANCE_PROJECT)
    );
  }, [hasRequiredProduct, userRole]);

  const onEnhanceClick = useCallback(() => {
    setModalState({ state: 'enhanceProjectIntro' });
  }, [setModalState]);

  return {
    hasPermissionToEnhanceProject,
    onEnhanceClick,
  };
};
